// extracted by mini-css-extract-plugin
export default {"wrapper":"ViewOrganizationTableCell_wrapper__wXfNq","avatar":"ViewOrganizationTableCell_avatar__N1MJ8"};